<template>
  <page-outline :title="$t('administration.user_add')">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutters">
          <back-button></back-button>
      </b-row>
      <form-accordion :title="$t('administration.user')" :isTitleUpperCase="false">
        <div class="form-group">
        </div>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="login" isMandatory
              :inputLabel="$t('administration.login')" :placeholderValue="$t('administration.login')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="name" isMandatory
              :inputLabel="$t('administration.name')" :placeholderValue="$t('administration.name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <label>
              {{ $t('administration.active') }}
            </label>
            <select class="form-control" id="sel4" v-model="active" readonly>
              <option value="0"> {{ $t('administration.no') }} </option>
              <option value="1"> {{ $t('administration.in_prgrss') }} </option>
              <option value="2"> {{ $t('administration.yes') }} </option>
            </select>
          </b-col>
          <b-col sm="6" class="form-group">
            <label>{{$t('common.pwd')}}</label>
            <div class="d-flex">
              <input v-model="password"
                class="form-control inputAccordionForm h-30px"
                :type="passwordType">
                <div class="icon icon-password mt-2 pt-1 icon-field"
                  :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                  @click="switchPasswordType">
                </div>
              </input>
            </div>
          </b-col>
        </b-row>
      </form-accordion>
      <br>
      <form-accordion :title="$t('administration.profile')"  :isTitleUpperCase="false">
        <b-row>
          <b-col cols="3">
            <label :title="$t('administration.select_profile')">{{ $t('administration.select_profile') }}</label>
            <a id="profile-picker-link" class="combo-list-field d-flex justify-content-between"
              href="#">
              <span :class="'fixed-span-size ' + (profileDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ profileDisplay.label }}</span>
              <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"></i>
            </a>
            <b-popover target="profile-picker-link"
              :title="$t('administration.select_profile')"
              triggers="focus" placement="bottom">
              <span v-for="(profile, index) in profiles" :key="$t('common.status.rtp.' + profile.id_rights_profile) + '-' + index">
                <b-form-checkbox v-model="profile.state"
                  :value="1"
                  :unchecked-value="0">
                  <span>{{ profile.libelle }}</span>
                </b-form-checkbox>
              </span>
            </b-popover>
          </b-col>
        </b-row>
      </form-accordion>
      <b-row class="accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters">
        <b-button variant="primary"
          @click="createUser()">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"

import {loadPage} from '@/helpers/routing'

export default {
  name: 'EditUserCompany',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton
  },
  props: ['idCompany'],
  computed: {
    isPasswordFieldHidden () {
      return this.passwordType === 'password'
    },
    profileDisplay () {
      let realProfileList = this.realProfileList.filter(status => status.state === 1)
      if (realProfileList.length === 0) {
        return {
          label: this.$t('administration.select_profile'),
          nb: 0
        }
      } else if (realProfileList.length < 3) {
        return {
          label: realProfileList.map(elem => elem.label).join(', '),
          nb: 1
        }
      } else {
        return {
          label: this.$t('administration.selected_profile_many', {nb: realProfileList.length}),
          nb: realProfileList.length
        }
      }
    },
    realProfileList () {
      let that = this
      const list = []
      for (const property in that.profiles) {
        const profile = that.profiles[property]
        list.push({
          tag: property,
          label: profile.libelle,
          state: profile.state,
          id: profile.id_rights_profile
        })
      }
      return list
    }
  },
  data () {
    return {
      login: '',
      name: '',
      active: '0',
      password: '',
      passwordType: 'password',
      profiles: [],
      id_rights_profile: ''
    }
  },
  created () {
    this.profiles = this.$engine.company.profiles.sort((a, b) => {
      return a.libelle.toUpperCase() > b.libelle.toUpperCase() ? 1 : -1
    })
  },
  methods: {
    createUser () {
      let that = this

      if (this.formHasError()) {
        return
      }

      this.$engine.usercompany.addUser(
        this.idCompany,
        {
          Login: this.login,
          Name: this.name,
          Active: this.active,
          Password: this.password ? this.password : undefined
        },
        this.realProfileList.filter(status => status.state === 1).map(elem => parseInt(elem.id))
      ).then(resp => {
        that.$f7.modal({
          title: that.$i18n.t('administration.user_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        that.$bus.$emit('switch-selected-menu', '/usercompany/')
        loadPage(that, {url: '/detail/' + that.idCompany})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.$f7.modal({
          title: that.$i18n.t('administration.user_addition_error'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      })
    },
    formHasError() {
      let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      if (this.login === undefined || this.login === '') {
        this.okMessageBox(this.$t('usercompany.missing_login'))
        return true
      }
      if (this.name === undefined || this.name === '') {
        this.okMessageBox(this.$t('usercompany.missing_name'))
        return true
      }
      if (this.password === undefined || this.password === '') {
        this.okMessageBox(this.$t('usercompany.missing_password'))
        return true
      }
      if (this.password && !regexPassword.test(this.password)) {
        this.okMessageBox(this.$t('profilesPage.password_wrong_format'))
        return true
      }
      if (!this.realProfileList.filter(status => status.state === 1).length) {
        this.okMessageBox(this.$t('usercompany.missing_profile'))
        return true
      }
      return false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchPasswordType () {
      console.log('switch', this.passwordType)
      if (this.passwordType === 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    }
  }
}
</script>
